import { createContext } from 'react';

export interface TranslationContextType {
  isTranslated: boolean;
  isTranslating: boolean;
  nodesBeingTranslated: number;
  currentLanguage: string;
  pendingLanguageChange: string | null;
  translationLock: string | null;
  originalTexts: Map<Element, string>;
  translationCache: Map<string, Map<string, string>>;
  changeLanguage: (lang: string) => Promise<void>;
  translatePage: (lang?: string) => Promise<void>;
  stopTranslation: (setToEnglish?: boolean) => Promise<void>;
  clearTranslationCache: () => void;
}

export const TranslationContext = createContext<TranslationContextType | null>(null);
